import { render, staticRenderFns } from "./SettingDescriber.vue?vue&type=template&id=3daf31f6"
import script from "./SettingDescriber.vue?vue&type=script&lang=ts"
export * from "./SettingDescriber.vue?vue&type=script&lang=ts"
import style0 from "./SettingDescriber.vue?vue&type=style&index=0&id=3daf31f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports